export const INTERESTS_QUERY_KEY = "interests";

export const queryKeys = {
  interests: (currentPage: number, profileId: number) => [INTERESTS_QUERY_KEY, currentPage, profileId]
};
